import { useEffect } from 'react';

/**
 * Custom hook to scroll to the top of the page
 */
export const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
}; 